import ComparisonBarComponent from '@/DesignSystem/features/comparison/ComparisonBar';
import { Box, Typography, useTheme } from '@mui/material';

const FixtureComparisonBarsComponent = ({ fixturePrediction, ...props }) => {
    const theme = useTheme();
    return (
        <Box border={`1px solid ${theme.palette.border.main}`} p={1} borderRadius={0.5} {...props}>
            <Typography component={'h2'} fontWeight={500}>
                Estadísticas generales
            </Typography>
            <ComparisonBarComponent
                left={fixturePrediction.comparison.att.home}
                right={fixturePrediction.comparison.att.away}
                parameter={'Mejor ataque'}
            />
            <ComparisonBarComponent
                left={fixturePrediction.comparison.def.home}
                right={fixturePrediction.comparison.def.away}
                parameter={'Mejor defensa'}
            />
            <ComparisonBarComponent
                left={fixturePrediction.comparison.form.home}
                right={fixturePrediction.comparison.form.away}
                parameter={'Forma actual'}
            />
            <ComparisonBarComponent
                left={fixturePrediction.comparison.goals.home}
                right={fixturePrediction.comparison.goals.away}
                parameter={'Histórico de goles'}
            />
            <ComparisonBarComponent
                left={fixturePrediction.comparison.h2h.home}
                right={fixturePrediction.comparison.h2h.away}
                parameter={'Enfrentamientos históricos'}
            />
            <ComparisonBarComponent
                left={fixturePrediction.comparison.poisson_distribution.home}
                right={fixturePrediction.comparison.poisson_distribution.away}
                parameter={'Distribución de Poisson'}
            />
            <ComparisonBarComponent
                left={fixturePrediction.comparison.total.home}
                right={fixturePrediction.comparison.total.away}
                parameter={'Porcentaje total'}
            />
        </Box>
    );
};

export default FixtureComparisonBarsComponent;
